import React from 'react'
import PropTypes from 'prop-types'
import { Divider } from '@blocket/blocket-ui'
import { UnderlineLink, TipWrapper, TipTitle, TipContent } from '../../style.js'

export const ChannelTipMessage = ({ tip, onTipClick }) => {
  return (
    <React.Fragment>
      <TipWrapper>
        {tip.title && <TipTitle>{tip.title}</TipTitle>}
        {tip.content && <TipContent>{tip.content}</TipContent>}
        {tip.url && (
          <UnderlineLink
            href={tip.url}
            onClick={onTipClick}
            rel="noopener noreferrer"
            target="_blank"
          >
            {tip.urlTitle}
          </UnderlineLink>
        )}
      </TipWrapper>
      <Divider />
    </React.Fragment>
  )
}

ChannelTipMessage.propTypes = {
  // 3rd party advertisement. Response from `messaging/v2/tip` endpoint (https://**YOUR_DEV**-api.dev.blocket.io/swagger/messaging.html)
  tip: PropTypes.object.isRequired,
  // Track 3d party ad click.
  onTipClick: PropTypes.func.isRequired,
}

export default ChannelTipMessage
